import { PageContainer, PageHeader } from "@repo/ui";
import { CarteCredits } from "@/components/parametres/CarteCredits";
import { CarteMotDePasse } from "@/components/parametres/CarteMotDePasse";
import { CarteProfil } from "@/components/parametres/CarteProfil";

export function Parametres() {
  return (
    <PageContainer>
      <PageHeader
        titre="Paramètres"
        sousTitre="Votre compte et les crédits de votre organisation"
      />
      <div className="space-y-6">
        <CarteCredits />
        <CarteProfil />
        <CarteMotDePasse />
      </div>
    </PageContainer>
  );
}
